import IllustratedList, { CollapseWrapper } from '@composites/IllustratedList';
import HeroSection from '@composites/HeroSection';
import VideoSection from '@composites/VideoSection';
import { getEventDetails } from '@store/slices/eventSlice';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { MetaTags } from '@components/MetaTags';
import { getImageSrc } from '@utils/fn';
import { useLocation } from 'react-router-dom';
import { SPEAKER_EMAIL } from '@utils/constants';
import { useTheme } from 'styled-components';
import { useMobileWidth } from '@utils/hooks';
import MailToButton from '@components/MailToButton';

const ChallengeYourPeersExplanationSpeakersPage = () => {
  const { t } = useTranslation();
  const sluggedEvent = useSelector(getEventDetails)?.[0];
  const { pathname } = useLocation();
  const theme = useTheme();
  const isMobile = useMobileWidth();
  const slug = pathname.split('/').filter(Boolean).pop() || '';

  const videoItems = [
    {
      id: 'Vi9dTKb5-2E',
      link: 'https://www.youtube.com/watch?v=Vi9dTKb5-2E',
      title: `we.CONECT - ${t('challenge-your-peers')} ${t('session')}`,
    },
  ];

  const subject = `${t('apply-as-a-speaker-request-subject', { eventName: sluggedEvent?.name })}`;
  const body = `${t('apply-as-a-speaker-request-body', { eventName: sluggedEvent?.name })}`;
  const mailtoLink = `mailto:${SPEAKER_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <>
      <MetaTags
        title={`${sluggedEvent?.name} ${slug?.split('-')?.join(' ')}`}
        description={`${sluggedEvent?.name} ${slug?.split('-')?.join(' ')}`}
        keywords={`${sluggedEvent?.slug}, ${slug?.split('-')?.join(', ')}`}
        image={getImageSrc(sluggedEvent?.design?.eventLogoPosSvg)}
        url={window.location.href}
        twitterCardType="summary"
        type="product"
      />
      <HeroSection
        title={t('event-networking-modal-text-15')}
        description={t('challenge-your-peers-hero-text')}
        darkOverlay
        button={
          <MailToButton
            href={mailtoLink}
            title={t('speakers-title-1')}
            backgroundColor={sluggedEvent?.design?.themeColor}
            hoverBackgroundColor={theme.color.mobilityGrey}
            textColor={theme.color.white}
            borderRadius={theme.borderRadius.radius10}
            fontSize={theme.fontSize.size20}
            lineHeight={theme.lineHeight.height150}
            padding={isMobile ? '1.5rem 2.5rem' : '1.1rem 4.9rem'}
            width="fit-content"
          />
        }
        backgroundImage={getImageSrc(
          'https://media.we-conect.com/images/website/cyp_workshop_hero_section.png',
          sluggedEvent?.portfolio?.slug
        )}
      />

      <VideoSection
        videoItems={videoItems}
        title={t('challenge-your-peers-video-title')}
        description=""
        buttonText={t('speakers-title-1')}
        buttonURL={mailtoLink}
      />

      <CollapseWrapper sluggedEvent={sluggedEvent}>
        <IllustratedList
          buttonText={t('speakers-title-1')}
          buttonURL={mailtoLink}
          image1={getImageSrc(
            'https://media.we-conect.com/images/website/challenge_your_peers_1.png',
            sluggedEvent?.portfolio?.slug
          )}
          image2={getImageSrc(
            'https://media.we-conect.com/images/website/challenge_your_peers_2.png',
            sluggedEvent?.portfolio?.slug
          )}
          orientation="left"
          sluggedEvent={sluggedEvent}
          listItems={Array.from({ length: 6 }, (_, index) => index + 1).map(
            (index: number) =>
              `how-does-challenge-your-peers-work-list-item-${index}`
          )}
          title={t('how-does-challenge-your-peers-work')}
        />

        <IllustratedList
          buttonText={t('speakers-title-1')}
          buttonURL={mailtoLink}
          image1={getImageSrc(
            'https://media.we-conect.com/images/website/challenge_your_peers_3.jpg',
            sluggedEvent?.portfolio?.slug
          )}
          image2={getImageSrc(
            'https://media.we-conect.com/images/website/challenge_your_peers_4.jpg',
            sluggedEvent?.portfolio?.slug
          )}
          orientation="right"
          sluggedEvent={sluggedEvent}
          listItems={Array.from({ length: 7 }, (_, index) => index + 1).map(
            (index: number) =>
              `how-can-you-prepare-a-challenge-your-peers-list-item-${index}`
          )}
          title={t('how-can-you-prepare-a-challenge-your-peers-session')}
        />
      </CollapseWrapper>
    </>
  );
};

export default ChallengeYourPeersExplanationSpeakersPage;
